import React, { useState, useEffect } from 'react';
import axios from 'axios';
import browserHistory from '../../history';
import Header from '../authentication/Header';
import Footer from '../authentication/Footer';
import Loader from '../Loader';

const getBase = () => (window.site && window.site.screeningApiBaseUrl) || 'https://content-screening-api.dev2.envoi.cloud';
const getApp = () => (window.app && window.app.appName) || 'kyliejenner';
const getUrlApp = () => (window.app && (window.app.urlAppName || window.app.appName)) || 'kyliejenner';
const getEnv = () => (window.app && window.app.appEnvName) || 'dev';
const getToken = () => (window.app && window.app.storage && window.app.storage.getItem('token')) || '';

function getArtistImage(artist) {
  const config = (window.site && window.site.config) || {};
  const cdn = config.sourceCloudFront || '';
  // const autoCompress = '?auto=compress,format&width=300';
  const autoCompress = '';
  const img = artist?.landscape_image || artist?.portrait_logo_image || artist?.thumbnail || '';
  if (!img) return (config.defaultLandscape || '') + autoCompress;
  if (img.startsWith('http')) return img.replace(/ /g, '%20') + autoCompress;
  return (cdn ? cdn + '/' + img.replace(/ /g, '%20') : img.replace(/ /g, '%20')) + autoCompress;
}

function getArtistName(artist) {
  return artist?.firstname + ' ' + artist?.lastname || artist?.name || artist?.title || '';
}

export default function HeirloomArtistPage({ creatorType, pageTitle }) {
  const [items, setItems] = useState([]);
  const [noOfAssets, setNoOfAssets] = useState(0);
  const [assetTotal, setAssetTotal] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [loadbtn, setLoadbtn] = useState('Load More');
  const assetCount = 12;

  useEffect(() => {
    setItems([]);
    setNoOfAssets(0);
    setAssetTotal(0);
    setPageNumber(1);
    setIsLoading(true);
    const url = `${getBase()}/getArtists?appname=${getApp()}&env=${getEnv()}&token=${getToken()}&assetcount=${assetCount}&pageNumber=1&scrubbing=true&creatorType=${encodeURIComponent(creatorType)}`;
    axios.get(url)
      .then(res => {
        const result = res.data?.result || {};
        const data = Array.isArray(result.data) ? result.data : (Array.isArray(result) ? result : []);
        const total = result.assetTotal || data.length;
        setItems(data);
        setNoOfAssets(data.length);
        setAssetTotal(total);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, [creatorType]);

  const loadMore = () => {
    const nextPage = pageNumber + 1;
    setLoadbtn('Loading...');
    const url = `${getBase()}/getArtists?appname=${getApp()}&env=${getEnv()}&token=${getToken()}&assetcount=${assetCount}&pageNumber=${nextPage}&scrubbing=true&creatorType=${encodeURIComponent(creatorType)}`;
    axios.get(url)
      .then(res => {
        const result = res.data?.result || {};
        const data = Array.isArray(result.data) ? result.data : (Array.isArray(result) ? result : []);
        const total = result.assetTotal || assetTotal;
        setItems(prev => [...prev, ...data]);
        setNoOfAssets(prev => prev + data.length);
        setAssetTotal(total);
        setPageNumber(nextPage);
      })
      .catch(() => {})
      .finally(() => setLoadbtn('Load More'));
  };

  const handleClick = (artist) => {
    const artistId = artist?.code || artist?._id;
    if (artistId) {
      browserHistory.push({ pathname: '/artist', search: `?artistId=${artistId}&appname=${getUrlApp()}`, state: { artistName: getArtistName(artist) } });
    }
  };

  return (
    <React.Fragment>
      <div className="recording_page">
        {isLoading && <Loader />}
        <Header />
        <React.Fragment>
          <div className="enchannel_wrapper minbody-ht" style={{ minHeight: 'calc(100vh - 180px)' }}>

            {!isLoading && items.length > 0 && (
              <div className="page-heading">
                <div className="perpage">
                  <div className="pull-left">{'Results: 1 to ' + noOfAssets + ' of ' + assetTotal}</div>
                </div>
              </div>
            )}

            {!isLoading && items.length > 0 ? (
              <>
                <div className="row">
                  {items.map((artist, i) => (
                    <div className="col-12 col-sm-4 col-md-3 col-lg-2" key={artist._id || i}>
                      <div className="channel-card">
                        <div
                          className="channel-thumb"
                          onClick={() => handleClick(artist)}
                          style={{ cursor: 'pointer' }}
                        >
                          <img alt={getArtistName(artist)} src={getArtistImage(artist)} />
                          <a
                            className="publish-btn selected rd_edit"
                            onClick={(e) => { e.stopPropagation(); handleClick(artist); }}
                            style={{ cursor: 'pointer' }}
                            title="info"
                          >
                            <span className="material-symbols-outlined">info</span>
                          </a>
                        </div>
                        <div className="channel-footer">
                          <h5>{getArtistName(artist)}</h5>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {noOfAssets < assetTotal && (
                  <div style={{ textAlign: 'center', clear: 'both' }}>
                    <button
                      onClick={loadMore}
                      style={{
                        padding: '10px 20px',
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        borderRadius: '5px',
                        color: '#fff',
                        fontSize: '16px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.4)';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                      }}
                    >
                      {loadbtn}
                    </button>
                  </div>
                )}
              </>
            ) : !isLoading ? (
              <div className="warning-wrapper empty-result">
                <img
                  src="https://envoi-common-resources.imgix.net/screening/images/common-images/no-data-found.jpg"
                  className="no-data-found"
                />
                <div className="error-text">
                  <h2 className="text-center">Sorry !</h2>
                  <p>There are no results available</p>
                </div>
              </div>
            ) : null}

          </div>
        </React.Fragment>
        <Footer />
      </div>
    </React.Fragment>
  );
}
